module.exports = __webpack_public_path__ + "img/zz.96816ac0.png";